var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.393,
    height: 23.475,
    viewBox: "0 0 27.393 23.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6910",
    "data-name": "Path 6910",
    d: "M74,2.907a11.561,11.561,0,0,1-2.806,3.015c.012.251.016.506.016.762,0,7.8-5.651,16.8-15.986,16.793a15.163,15.163,0,0,1-8.617-2.7,10.67,10.67,0,0,0,1.341.086,10.848,10.848,0,0,0,6.98-2.541,5.712,5.712,0,0,1-5.25-4.182,5.193,5.193,0,0,0,1.057.116,5.31,5.31,0,0,0,1.48-.2,5.969,5.969,0,0,1-4.51-5.913V8.065a5.4,5.4,0,0,0,2.547.779,6.188,6.188,0,0,1-2.5-5.021A6.224,6.224,0,0,1,48.513.816,15.824,15.824,0,0,0,60.1,7.216a6.234,6.234,0,0,1-.146-1.357A5.677,5.677,0,0,1,65.573,0a5.588,5.588,0,0,1,4.1,1.934A10.787,10.787,0,0,0,73.244.562,5.766,5.766,0,0,1,70.771,3.79,10.762,10.762,0,0,0,74,2.907",
    transform: "translate(-46.607 -0.003)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e6ed22980d46306df9bfea128ed7da8c.svg";
export { ForwardRef as ReactComponent };